import React, { Component } from 'react';
import { IHomePageBoxActivityProps } from '../../models/components/homepage-box-activity';
import { IAppState, IAction } from '../../models/action/core';
import { connect } from 'react-redux';
import { Log } from 'ng2-logger';
import { Redirect } from 'react-router-dom';
import Translator from '../../core/i18n';
import Loading from '../loading/loading';
import { ActivityFilterGrade } from '../../models/enums/activityFilters';
import * as Actions from '../../store/actions/profile';
import { IProfileProps } from '../../models/pages/profile';
import ContentLoader from 'react-content-loader';
import { IPreference } from '../../models/action/profile';
import * as CoursePageActions from '../../store/actions/coursePage';
import ShowAllButton from '../show-all-button/main';

const T = Translator.create();
const _logger = Log.create('ActivityStats Box');

export class CActivityStats extends Component<IHomePageBoxActivityProps & IProfileProps> {
    state = {
        redirect: false,
        redirectUrl: '/',
        boxItems: ['0', '1', '2', '3', '4', '5', '6', '7', '8'],
        boxItemsVisual: [false, false, false, false, false, false],
        boxCount: 0
    };

     public handleChange = () => {
            const { userPreferences, dispatch } = this.props;
            const { boxItems, boxItemsVisual } = this.state;
    
            const updateBoxItemsVisual = (items: string[]) => {
                items.forEach(item => {
                    boxItemsVisual[parseInt(item, 10)] = true;
                });
            };
    
            const updatePreferences = (items: string[]) => {
                const preferencesValue = items.toString();
                const preferenceData = {
                    preferences: [{ name: 'home.index.boxallowed', value: preferencesValue }]
                };
                dispatch(Actions.addOrUpdatePreferencesAction(preferenceData));
            };
    
            if (userPreferences && userPreferences.length > 0) {
                const preference = userPreferences.find((pref: any) => pref.name === 'home.index.boxallowed');
                if (preference && preference.value) {
                    const updatedBoxItems = preference.value.split(',').filter(item => item !== '1');
                    this.setState({ boxItems: updatedBoxItems });
                    updateBoxItemsVisual(updatedBoxItems);
                    updatePreferences(updatedBoxItems);
                }
            } else {
                const updatedBoxItems = boxItems.filter(item => item !== '1');
                this.setState({ boxItems: updatedBoxItems });
                updateBoxItemsVisual(updatedBoxItems);
                updatePreferences(updatedBoxItems);
            }
        };

    onClick = (event: any) => {
        this.setState({ redirect: true, redirectUrl: event.currentTarget!.getAttribute('data-redirectLink') });
    };

    componentDidMount () {
        if (!this.props.loaded)
        {
        this.props.dispatch(CoursePageActions.getMyActivityStatsGetAction({ Take: 10, Skip: 0 }, 'getHomeBoxActivityStats', 'get'));
        }
        if (this.props.userPreferences!.length > 0) {
            if (this.props.userPreferences!.find(pref => pref.name === 'home.index.boxcount')) {
                this.setState({
                    boxCount: (this.props.userPreferences!.find(pref => pref.name === 'home.index.boxcount') as IPreference).value
                });
            }
        }
    }

    public render() {
        const initialFormValues = {
            ...this.props.profileData,
            userPreferences: this.props.userPreferences,
            handleChange: this.handleChange
        };
        const loadingSpaces = 63;
        const loadingSizes = this.state.boxCount === 2 ? '0 0 540 300' : '0 0 350 300';
        const loadingWidth = this.state.boxCount === 2 ? 540 : 350;
        let myTotalActivityCount = 0;
        if(this.props.myActivityStats){
            myTotalActivityCount = this.props.myActivityStats[0].outDated + this.props.myActivityStats[0].incoming + this.props.myActivityStats[0].completed + this.props.myActivityStats[0].notGraded;
        }
        if (this.state.redirect) {
            return <Redirect push={true} to={window.appSettings.DEFAULT_URL + '/' + this.state.redirectUrl} />;
        }
        return (
            <div className="white-box ">
                <div className="d-flex justify-content-between white-box-header">
                    <div>
                        <span className='lms-header-medium' tabIndex={0}>
                            {T.t('r_home_index_box_activity')}
                            <span className='badge badge-pill badge-light py-1 px-2' style={{marginInlineStart: "0.5rem"}}  tabIndex={0}>
                                {myTotalActivityCount}
                            </span>
                        </span>
                    </div>
                    <div className="align-self-center">
                        <i
                            className="material-icons mr-2 align-middle"
                            onClick={this.handleChange}
                            style={{ cursor: 'pointer' }}
                        >
                            visibility
                        </i>
                        <ShowAllButton redirectUrl='/u/activities-dashboard/'/>
                    </div>
                </div>
                <Loading spinnerId={'getHomeBoxActivityStats'}>
                    <div style={{ backgroundColor: '#fbfaf6' }}>
                        <ContentLoader
                            speed={2}
                            backgroundColor="#f3f3f3"
                            foregroundColor="#ecebeb"
                            viewBox={loadingSizes}
                            style={{ width: '100%' }}
                        >
                            <rect x="16" y="22" rx="3" ry="3" width="140" height="12" />
                            <circle cx="185" cy="28" r="11" />

                            <rect x="0" y={loadingSpaces - 7} rx="3" ry={loadingSpaces - 7 + 3} width={loadingWidth} height="1" />

                            <rect x="16" y={22 + loadingSpaces} rx="3" ry={3 + loadingSpaces} width="150" height="12" />
                            <circle cx="195" cy={28 + loadingSpaces} r="11" />

                            <rect x="0" y={loadingSpaces * 2 - 7} rx="3" ry={loadingSpaces * 2 - 7 + 3} width={loadingWidth} height="1" />

                            <rect x="16" y={22 + loadingSpaces * 2} rx="3" ry={3 + loadingSpaces * 2} width="130" height="12" />
                            <circle cx="175" cy={28 + loadingSpaces * 2} r="11" />

                            <rect x="0" y={loadingSpaces * 3 - 7} rx="3" ry={loadingSpaces * 2 - 7 + 3} width={loadingWidth} height="1" />

                            <rect x="16" y={22 + loadingSpaces * 3} rx="3" ry={3 + loadingSpaces * 3} width="120" height="12" />
                            <circle cx="165" cy={28 + loadingSpaces * 3} r="11" />
                        </ContentLoader>
                    </div>
                </Loading>
                <div id="getHomeBoxActivityStats_Content" className="white-box-body pr-0 pt-0">
                    {this.props.myActivityStats ? (
                        this.props.myActivityStats.map((stats: any, key: any) => {
                            return (
                                <ul className="student-activity-list list-unstyled" key={key}>
                                    <li>
                                        {' '}
                                        <a data-redirectLink={'u/activities-dashboard?isDatePassed=1'} onClick={this.onClick} tabIndex={0}>{T.t('r_home_box_activity_outdated')}</a>{' '}
                                        <span>{stats.outDated}</span>{' '}
                                    </li>
                                    <li>
                                        {' '}
                                        <a data-redirectLink={'u/activities-dashboard?dueDate=1'} onClick={this.onClick} tabIndex={0}>{T.t('r_home_box_activity_incoming')}</a>{' '}
                                        <span>{stats.incoming}</span>
                                    </li>
                                    <li>
                                        {' '}
                                        <a data-redirectLink={'u/activities-dashboard?grade=' + ActivityFilterGrade.NotGraded} onClick={this.onClick} tabIndex={0}>{T.t('r_home_box_activity_not_graded')}</a>{' '}
                                        <span>{stats.notGraded}</span>
                                    </li>
                                    <li>
                                        {' '}
                                        <a data-redirectLink={'u/activities-dashboard?completed=1'} onClick={this.onClick} tabIndex={0}>{T.t('r_home_box_activity_completed')}</a>{' '}
                                        <span>{stats.completed}</span>
                                    </li>
                                </ul>
                            );
                        })
                    ) : (
                            <p tabIndex={0}>{T.t('r_home_box_activity_stats_not_found')}</p>
                        )}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: IHomePageBoxActivityProps): IHomePageBoxActivityProps => {
    if (!state) {
        return ownProps;
    }

    const newProps: IHomePageBoxActivityProps = Object.assign({}, ownProps, {
        myActivityStats: state.coursePage.myActivityStats,
        userPreferences: state.profile.userPreferences.preferences
    });

    return newProps;
};

const ActivityStats = connect(mapStateToProps)(CActivityStats);

export default ActivityStats;
